import { Map } from 'immutable'
import { createSelector } from 'reselect'

import { getIsCustomerDynamicSessionLimitFeatureFlagEnabled } from '../featureFlags/featureFlagSelectors'

/**
 * Selectors that combine state from multiple domains (user, customer, feature flags, etc.)
 * This file helps avoid circular dependencies between domain-specific selector files.
 */

export const getIsCustomerDynamicSessionLimitEnabled = createSelector(
  [
    (state: Map<string, any>) => state?.get('user')?.size > 0, // getIsUserLoggedIn logic
    getIsCustomerDynamicSessionLimitFeatureFlagEnabled,
  ],
  (isUserLoggedIn, isCustomerDynamicSessionLimitFeatureFlagEnabled) => {
    // only enable dynamic session limit for logged out users
    return isCustomerDynamicSessionLimitFeatureFlagEnabled && !isUserLoggedIn
  },
)
